var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollContainer",staticClass:"scroll-container"},[_c('div',{ref:"padded",staticClass:"padder"},[_c('div',{ref:"contentContainer",staticClass:"content-wrapper"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }